import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { AsyncDispatch } from '../../../types/global';
import {
  fetchCustomAppConfigs as fetchCustomAppConfigsAction,
  createCustomAppConfig as createCustomAppConfigAction,
  updateCustomAppConfig as updateCustomAppConfigAction,
  deleteCustomAppConfig as deleteCustomAppConfigAction,
} from '../../actions/customApps';
import SettingsCustomAppsPage from '../../components/body/settings/customApps/SettingsCustomAppsPage';
import { useAppDispatch } from '../../store/ReduxStore';

const SettingsCustomAppsContainer: React.FC = () => {
  const dispatch: AsyncDispatch = useAppDispatch();

  const configs = useSelector((state: ApplicationState) => state.customAppsSettings.configs);
  const availableApps = useSelector((state: ApplicationState) => state.tools.replit.integrations);
  const fetchingConfigs = useSelector(
    (state: ApplicationState) => state.customAppsSettings.fetchingConfigs
  );
  const fetchingAvailableApps = useSelector(
    (state: ApplicationState) => state.tools.replit.fetchingIntegrations
  );
  const savingConfig = useSelector(
    (state: ApplicationState) => state.customAppsSettings.savingConfig
  );
  const deletingConfig = useSelector(
    (state: ApplicationState) => state.customAppsSettings.deletingConfig
  );

  const createCustomAppConfig = useCallback(
    async (config: any) => {
      await dispatch(createCustomAppConfigAction(config));
      dispatch(fetchCustomAppConfigsAction());
    },
    [dispatch]
  );

  const updateCustomAppConfig = useCallback(
    async (configId: number, config: any) => {
      await dispatch(updateCustomAppConfigAction(configId, config));
      dispatch(fetchCustomAppConfigsAction());
    },
    [dispatch]
  );

  const deleteCustomAppConfig = useCallback(
    async (configId: number) => {
      await dispatch(deleteCustomAppConfigAction(configId));
      dispatch(fetchCustomAppConfigsAction());
    },
    [dispatch]
  );

  return (
    <SettingsCustomAppsPage
      configs={configs}
      availableApps={availableApps}
      fetchingConfigs={fetchingConfigs}
      fetchingAvailableApps={fetchingAvailableApps}
      savingConfig={savingConfig}
      deletingConfig={deletingConfig}
      createCustomAppConfig={createCustomAppConfig}
      updateCustomAppConfig={updateCustomAppConfig}
      deleteCustomAppConfig={deleteCustomAppConfig}
    />
  );
};

export default SettingsCustomAppsContainer;
